module.exports = __webpack_public_path__ + "/dot_com_ui/img/tech-hiccup-42d52200788fe3217384707f5caff85c.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/tech-hiccup.png
// module id = 452
// module chunks = 1